export enum Tab {
    CATEGORY = 'Category',
    PRODUCT = 'Product',
    PAGE = 'Page',
    OTHER = 'Other',
    CATEGORY_HUB = 'Category Hub',
    IMAGES = 'Images',
}